export default {
    // 所有路由配置group,值为所属一级导航的name
    home: 'home',
    incomeOverview: 'list',
    incomeList: 'list',
    login: '',
    open: 'open',
    openCard: 'card',
    orderDetail: 'open',
    profitOrderDetail: 'list',
    orderEdit: 'open',
    orderList: 'open',
    // workerOrderList: 'open',
    // workerOrderDetail: 'open',
    checkCarExam: 'open',
    carExamEdit: 'open',
    storeCardEdit: 'card',
    client: 'client',
    cars: 'client',
    carsDetail: 'client',
    carsHistory: 'client',
    carsHistoryDetails: 'client',
    carsInspectionTemplateEdit: 'auth',
    prePaid: 'card',
    prePaidEdit: 'card',
    clientPromot: 'card',
    prePaidRecord: 'card',
    clientDetail: 'client',
    pageNotFound: '',
    systemMaintenance: '',
    operators: 'member',
    staffEdit: 'auth',
    staffList: 'auth',
    roleList: 'auth',
    roleEdit: 'auth',
    orderSetting: 'auth',
    notice: 'home',
    noticeDetail: 'home',
    logList: 'auth',
    predict: 'card',
    prePaidCrt: 'card',
    printOrder: '',
    printStoreDetail: '',
    historyList: 'open',
    selfGoods: 'store',
    selfGoodsEdit: 'store',
    enterStoreDetail: 'store',
    outStoreDetail: 'store',
    agencyGoods: 'store',
    enterStore: 'store',
    outStore: 'store',
    addAgencyGoods: 'store',
    serverReserve: 'list',
    dataOverview: 'list',
    analyseGoods: 'list',
    analyseRepairCard: 'list',
    analyseSalesActivity: 'list',
    analyseStoreCard: 'list',
    analyseCustomer: 'list',
    writeoffList: 'list',
    writeoffDetail: 'list',
    carsInspectionTemplate: 'auth',
    carsExamReport:'open',
    addCarExam:'open',
    serviceList: 'service',
    serviceEdit: 'service',
    maintenancePlan: 'card',
    maintenanceRecord: 'card',
    maintenanceRecordDetails: 'card',
    couponList: 'card',
    couponOwner: 'card',
    couponLaunch: 'card',
    editCoupon: 'card',
    seeCoupon: 'card',
    analyseCoupon: 'list',
    vipExplain: '',
    carHistoryOrderDetail: 'client',
};



// WEBPACK FOOTER //
// ./src/router/pageGroup.js